import { useEffect, useState } from "react";
import Button from "../UI/Button";
import { useDispatch } from "react-redux";
import { sendWinnerAnnouncementNotification } from "../../redux/createMessage/slice";
import firebase from "../../firebase/config";

export default function WinnerAnnouncement() {
  const [messages, setMessages] = useState({
    title: "",
    descriptionForPushNotification: "",
    descriptionForEmail: "",
    announcementDate: "",
    pushNotificationAndEmailDate: "",
    pushNotificationAndEmailHours: "",
    pushNotificationAndEmailMinutes: "",
    sendPushNotification: true,
    sendEmail: true
  });

  const [success, setSuccess] = useState(""); // to display message if the message is sent or not
  const [error, setError] = useState("");
  const [sendPushNotification, setSendPushNotification] = useState(true); // State to track if notification is to be sent now
  const [sendEmail, setSendEmail] = useState(true); // State to track if notification is to be sent now

  const dispatch = useDispatch();
  const resetForm = () => {
    setMessages((prev) => ({
      ...prev,
      announcementDate: "",
      pushNotificationAndEmailDate: "",
      pushNotificationAndEmailHours: "",
      pushNotificationAndEmailMinutes: ""
    }));
    setSuccess("Push notification and email added successfully");
    setError("");

    setTimeout(() => {
      setSuccess("");
    }, 3000);
  };


  //getting prize data from firebase
  useEffect(() => {
    const fetchPrizeData = async () => {
      try {
        const db = firebase.firestore();
        setMessages((prev) => ({
          ...prev,
          title: "Winner Announcement",
          descriptionForPushNotification: `Congratulations to XXXX for winning the “Single Run” challenge!
Congratulations to XXXX for winning the “All Time” challenge!
We will make contact with the winners to ensure they receive their awesome prizes. You can also contact us on Fernandes.driver@fernandes.sr`,

          descriptionForEmail: `Dear Fernandes Drivers,
Congratulations to XXXX for winning the “Single Run” challenge!
Congratulations to XXXX for winning the “All Time” challenge!
We will make contact with the winners to ensure they receive their awesome prizes. You can also contact us on Fernandes.driver@fernandes.sr
Did you miss out on the prizes this time? The next winners will be announced on ${messages.announcementDate || "XXXX"}, so be ready and put on a great performance!`,
          announcementDate: "",
          sendEmail: true,
          sendPushNotification: true,
        }));

        console.log("updated data of messages", messages)
      } catch (error) {
        console.error("Error fetching document: ", error);
      }
    };

    fetchPrizeData();
  }, []);

  const convertDateFormatOfAnnouncementDate = (dateString: any) => {
    const [year, month, day] = dateString.split("-").map(Number); // Convert strings to numbers

    // Array of month names
    const monthNames = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];

    // Get the month name from the month number
    const monthName = monthNames[month - 1]; // Month is 1-indexed

    return `${day} ${monthName} ${year}`; // Returns format like '16 October 2024'
  };

  useEffect(() => {
    const formattedDate = convertDateFormatOfAnnouncementDate(messages.announcementDate);

    setMessages((prevMessages) => ({
      ...prevMessages,
      descriptionForEmail: `Dear Fernandes Drivers,\n${prevMessages.descriptionForPushNotification}!\nDid you miss out on the prizes this time? The next winners will be announced on ${messages.announcementDate === "" ? "XXXX" : formattedDate}, so be ready and put on a great performance!`,
    }));
  }, [messages.announcementDate]);

  const getMessages = (e: any) => {
    setMessages((prevMessages) => ({
      ...prevMessages,
      [e.target.name]: e.target.value,
      isAddedInInGameNotification: false

    }));
    console.log("get msg, msg data is", messages);
  };

  //submitting form data here and sending
  const saveMessage = async (e: any) => {
    e.preventDefault();
    const { descriptionForEmail, descriptionForPushNotification, title, prizeDetails, pushNotificationAndEmailDate, announcementDate, pushNotificationAndEmailHours, pushNotificationAndEmailMinutes } = e.target;
    let isValid: boolean = true;
    const pushNotificationAndEmailTime = `${pushNotificationAndEmailHours.value}:${pushNotificationAndEmailMinutes.value}`

    console.log("save msg, msd datda before", messages);
    console.log("save msg, event datda before", pushNotificationAndEmailDate.value);

    const currentDate = new Date();
    const currentDateInMiliseconds = currentDate.setUTCHours(currentDate.getUTCHours() - 3) //converted to suriname time

    const pushNotificationDateAndTime = `${pushNotificationAndEmailDate.value}T${pushNotificationAndEmailTime}:00`
    let convertedPushNotificationAndEmailDate = new Date(pushNotificationDateAndTime).getTime()
    convertedPushNotificationAndEmailDate = convertedPushNotificationAndEmailDate + (6 * 60 * 60 * 1000) //converted to suriname time
    console.log("convertedPushNotificationAndEmailDate", convertedPushNotificationAndEmailDate)

    function formatInOnlyDate(date: any) {
      const year = date.getFullYear(); // Get the full year
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Get month (0-11) and format as two digits
      const day = String(date.getDate()).padStart(2, '0'); // Get day and format as two digits

      // Combine them into a date string (YYYY-MM-DD format)
      return `${year}-${month}-${day}`;
    }

    const formattedCurrentDate = formatInOnlyDate(currentDate);
    console.log("formattedCurrentDate", formattedCurrentDate); // Output: "2024-10-29" (for example)
    const formattedConvertedPushNotificationAndEmailDate = formatInOnlyDate(new Date(pushNotificationDateAndTime));
    console.log("formattedConvertedPushNotificationAndEmailDate", formattedConvertedPushNotificationAndEmailDate); // Output: "2024-10-29" (for example)

    if (
      descriptionForPushNotification.value.trim() === ""
    ) {
      setError("Please select Description for push notification correctly");
      setSuccess("");
      isValid = false;
    } else if (
      descriptionForEmail.value.trim() === ""
    ) {
      setError("Please select Description for email correctly");
      setSuccess("");
      isValid = false;
    } else if (title.value.trim() === "") {
      setError("Please select title correctly");
      setSuccess("");
      isValid = false;
    }
    else if (pushNotificationAndEmailDate.value === "") {
      setError("Please select Push Notification Date correctly");
      setSuccess("");
      isValid = false;
    } else if (pushNotificationAndEmailTime === "") {
      setError("Please select Push Notification Time correctly");
      setSuccess("");
      isValid = false;
    } else if (announcementDate.value === "") {
      setError("Please select Announcement Date correctly");
      setSuccess("");
      isValid = false;
    } else if (formattedCurrentDate == formattedConvertedPushNotificationAndEmailDate && announcementDate.value !== "") {
      if (currentDateInMiliseconds <= convertedPushNotificationAndEmailDate) {
        isValid = true;
        console.log("current date in if", currentDateInMiliseconds)
        console.log("convertedPushNotificationAndEmailDate", convertedPushNotificationAndEmailDate)
      } else {
        setError("Please select valid time for Push Notification");
        setSuccess("");
        isValid = false;
      }
    }
    else if (currentDateInMiliseconds > convertedPushNotificationAndEmailDate) {
      setError("Please select valid date for Push Notification");
      setSuccess("");
      isValid = false;
    } else if (!sendEmail && !sendPushNotification) {
      setError("Please choose atleast one option between Description for Email/Description for Push Notification");
      setSuccess("");
      isValid = false;
    }
    if (title.value.trim().length <= 5 || title.value.trim().length >= 30) {
      setError("Make sure that, title has more than 10 and less than 30 characters");
      setSuccess("");
      isValid = false
    }

    if (isValid) {
      const messageData = {
        ...messages,
        pushNotificationAndEmailTime: pushNotificationAndEmailTime,
        notificationUID: crypto.randomUUID()
      };
      console.log("save msg, msd datda after", messageData);
      dispatch(sendWinnerAnnouncementNotification(messageData));
      resetForm()
    }

  };

  return (
    <main>
      <div className="container-fluid px-4">
        <div>
          <h1>Prize Distribution</h1>
        </div>
        <div className="row">
          <div className="col-md-12">
            <form onSubmit={saveMessage}>
              <div className="form-row">
                Title<input
                  type="text"
                  className="form-control"
                  style={{ color: "black" }}
                  id=""
                  value={messages.title}
                  name="title"
                />
              </div>
              <div className="form-row">
                Push Notification/Email Date (Push notification and Emails will be sent on this Date)<input
                  type="date"
                  className="form-control"
                  style={{ color: "black" }}
                  onKeyDown={(e) => e.preventDefault()}
                  name="pushNotificationAndEmailDate"
                  onChange={getMessages}
                  value={messages.pushNotificationAndEmailDate}
                />
              </div>

              <div style={{ display: 'flex', alignItems: 'center' }}>
                Time for Push Notification:
                <select
                  name="pushNotificationAndEmailHours"
                  onChange={getMessages}
                  className="form-control"
                  style={{ width: '70px', margin: '5px', color: 'black' }}
                  value={messages.pushNotificationAndEmailHours}
                >
                  {Array.from({ length: 24 }, (_, i) => (
                    <option key={i} value={i < 10 ? `0${i}` : i}>
                      {i < 10 ? `0${i}` : i}
                    </option>
                  ))}
                </select>
                <span>:</span>
                <select
                  name="pushNotificationAndEmailMinutes"
                  onChange={getMessages}
                  className="form-control"
                  style={{ width: '70px', marginLeft: '5px', color: 'black' }}
                  value={messages.pushNotificationAndEmailMinutes}
                >
                  {Array.from({ length: 60 }, (_, i) => (
                    <option key={i} value={i < 10 ? `0${i}` : i}>
                      {i < 10 ? `0${i}` : i}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-row">
                Next Announcement Date<input
                  type="date"
                  className="form-control"
                  style={{ color: "black" }}
                  onKeyDown={(e) => e.preventDefault()}
                  name="announcementDate"
                  onChange={getMessages}
                  value={messages.announcementDate}

                />
              </div>

              <div className="form-row">
                <input
                  type="checkbox"
                  className="form-check-input"
                  name="sendPushNotification"
                  style={{ marginRight: "8px" }}
                  onChange={() => {
                    setSendPushNotification((prev) => !prev); // Toggle send now state
                    setMessages((prevMessages) => ({
                      ...prevMessages,
                      sendPushNotification: !prevMessages.sendPushNotification,
                    }));
                  }}
                  checked={sendPushNotification} />
                Description for Push Notification (Non-Editable)<textarea
                  className="form-control"
                  style={{ lineHeight: "normal", padding: "1.5%", color: "black", whiteSpace: "pre-wrap" }}
                  id=""
                  value={messages.descriptionForPushNotification}
                  name="descriptionForPushNotification"
                ></textarea>
              </div>

              <div className="form-row">
                <input
                  type="checkbox"
                  className="form-check-input"
                  name="sendEmail"
                  style={{ marginRight: "8px" }}
                  onChange={() => {
                    setSendEmail((prev) => !prev); // Toggle send now state
                    setMessages((prevMessages) => ({
                      ...prevMessages,
                      sendEmail: !prevMessages.sendEmail,
                    }));
                  }}
                  checked={sendEmail} />
                Description for Email (Non-Editable)<textarea
                  className="form-control"
                  style={{ lineHeight: "normal", padding: "1.5%", color: "black", whiteSpace: "pre-wrap" }}
                  id=""
                  value={messages.descriptionForEmail}
                  name="descriptionForEmail"
                ></textarea>
              </div>

              {error && <p style={{ color: "red" }}>{error}</p>}
              {success && <p style={{ color: "green" }}>{success}</p>}

              <Button text="Submit" className="btn btn-primary btn-lg" />
            </form>
          </div>
        </div>
      </div>
    </main>
  );
}

